"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
Object.defineProperty(Intl, 'Locale', {
    value: _1.Locale,
    writable: true,
    enumerable: false,
    configurable: true,
});
